module.exports = __webpack_public_path__ + "static/media/king.e561501b.jpg";